import en from "./en.json";
import ja from "./ja.json";
import kr from "./kr.json";
import charmEn from "./charmEn.json";
import charmJa from "./charmJa.json";
import charmKr from "./charmKr.json";

export const talentDeckLocales = { en, ja, kr };
export const charmLocales = { charmEn, charmJa, charmKr };
